module.exports = __webpack_public_path__ + "joy-static/media/FlickIcon.e5a6a29b.svg";